import axios from '@fs/zion-axios'
import type { Axios } from '@fs/zion-tree-types/zion-axios'

const treeDataBaseUrl = '/service/tree/tree-data'

type Props = {
  treeId?: string
  nameFilter?: string
}

type Response = {
  count: number
}

export default async function getPrivatePeopleCount({ treeId, nameFilter }: Props): Promise<Response> {
  let url = `${treeDataBaseUrl}/trees/${treeId || 'PRIVATE'}/persons/count`
  if (nameFilter) url += `?nameFilter=${nameFilter}`
  const config = { headers: {} }

  return (axios as Axios).get<Response>(url, config).then((res) => res.data)
}
